import { render, staticRenderFns } from "./team-inbox-alert-modal.vue?vue&type=template&id=c274764e&scoped=true"
import script from "./team-inbox-alert-modal.vue?vue&type=script&lang=js"
export * from "./team-inbox-alert-modal.vue?vue&type=script&lang=js"
import style0 from "./team-inbox-alert-modal.vue?vue&type=style&index=0&id=c274764e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c274764e",
  null
  
)

export default component.exports